/** +camera: "Camera" section of the settings panel (follow style). Persisted by render/cameraSettings.ts. */
import type { CameraFollowMode } from '../render/camera';
import { CAMERA_FOLLOW_MODES } from '../render/camera';
import { cameraSettings } from '../render/cameraSettings';
import { el } from './dom';

const FOLLOW_LABEL: Record<CameraFollowMode, string> = { never: 'Never', smart: 'Smart (WoW)', always: 'Always' };

/** Adds the Camera section. Returns a sync function. */
export function mountCameraControls(panel: HTMLElement, before: Node | null = null): () => void {
  const section = el('div', 'cam-settings');
  panel.insertBefore(section, before);
  el('div', 'gfx-title', section, 'Camera');
  const row = el('label', 'gfx-row', section);
  el('span', '', row, 'Camera follow');
  const select = el('select', '', row);
  for (const m of CAMERA_FOLLOW_MODES) el('option', '', select, FOLLOW_LABEL[m]).value = m;
  select.addEventListener('change', () => cameraSettings.set({ follow: select.value as CameraFollowMode }));
  el('div', 'gfx-hint', section, 'Smart: starting to move or turn swings the camera back behind your character (best with WoW controls). Mouse wheel zooms from 3 to 70 yards.');
  return () => {
    select.value = cameraSettings.get().follow;
  };
}
